module.exports = __webpack_public_path__ + "static/media/person.3edf8f1d.svg";